import React from "react";
import styles from "./TreatmentSearch.module.scss";
import { useTreatmentSearch } from "./hooks/useTreatmentSearch";

export const TreatmentSearch = ({ editData = [], getData, dressing }) => {
  const { dropRef, inputValue, open, filteredOptions, selectedChips, setInputValue, isSelected, toggleItem, handleClear, handleRemove, handleFocus } =
    useTreatmentSearch({ editData, getData });

  return (
    <div className={styles.searchWrapper} ref={dropRef}>
      <div className={styles.searchContainer}>
        <div className={styles.searchIcon}>
          <i className="fa fa-search" aria-hidden="true" />
        </div>

        <div className={styles.inputArea}>
          {selectedChips.length > 0 && (
            <div className={styles.chips}>
              {selectedChips.map((item) => (
                <div key={`${item.key}-${item.value}`} className={styles.chip}>
                  <span className={styles.chipCategory}>{item.opt.parentName}</span>
                  <span className={styles.chipText}>
                    {[item.opt.productFamilyDesc, item.opt.materialCode && `(${item.opt.materialCode})`].filter(Boolean).join(" ")}
                  </span>
                  <button
                    data-testid={`clear-btn-${item.key}`}
                    type="button"
                    className={styles.clearBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemove(item?.opt?.materialNumber);
                    }}
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                  </button>
                </div>
              ))}
            </div>
          )}
          <input
            type="text"
            className={styles.searchInput}
            placeholder={"Search by code, description or product family…"}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onFocus={handleFocus}
          />
        </div>

        {inputValue && (
          <button type="button" className={styles.clearBtn} onClick={handleClear}>
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        )}
      </div>

      {open && (
        <div className={styles.dropdown}>
          {filteredOptions.length === 0 ? (
            <div className={styles.noResults}>No results found</div>
          ) : (
            <div className={styles.resultsList}>
              {filteredOptions.map((opt) => {
                const checked = isSelected(opt.materialNumber, opt.parentKey);
                return (
                  <div
                    data-testid={`${opt.parentKey}-${opt.materialNumber}`}
                    key={`${opt.parentKey}-${opt.materialNumber}`}
                    className={`${styles.resultItem} ${checked ? styles.active : ""}`}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleItem(opt);
                    }}
                  >
                    <div className={styles.checkboxContainer}>
                      <input type="checkbox" checked={checked} readOnly />
                    </div>
                    <div className={styles.itemContent}>
                      <div className={styles.parentLabel}>{opt.parentName}</div>
                      <div className={styles.productFamily}>{opt.productFamilyDesc}</div>
                      <div className={styles.materialContent}>
                        <div className={styles.materialDescription}>{opt.materialDescription}</div>
                        <div className={styles.materialCode}>{opt.materialCode}</div>
                      </div>
                    </div>
                    {dressing !== "secondary" && opt?.isRecommended === 1 && <div className={styles.recommended}>Recommended</div>}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
